import { PaymentTypesGridView } from '~/components/order/payment-types/grid';
import { PageContainer } from '~/components/page-container';

export function PaymentTypes() {
	return (
		<PageContainer>
			<PaymentTypesGridView />
		</PageContainer>
	);
}
